<template>
  <div id="login-page">
    <div class="login-card">

      <div class="login-logo">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="181.309"
          height="63.114"
          viewBox="0 0 181.309 63.114"
        >
          <g id="Group_12" data-name="Group 12" transform="translate(-0.186 -2.451)">
            <path id="Path_2" data-name="Path 2" d="M501.783,27.63V26.272c.683-.168,1.351-.31,2.006-.5a3.143,3.143,0,0,0,2.091-2.07c.48-1.292.9-2.606,1.35-3.911.467-1.362.939-2.722,1.4-4.086.417-1.23.822-2.464,1.239-3.694.464-1.364.939-2.723,1.4-4.086.415-1.22.822-2.443,1.234-3.664.447-1.326.894-2.654,1.356-3.974a.431.431,0,0,1,.33-.221q1.244-.028,2.489,0a.439.439,0,0,1,.328.229c.566,1.475,1.109,2.958,1.665,4.437.514,1.367,1.04,2.726,1.554,4.092.415,1.1.818,2.208,1.233,3.312s.838,2.2,1.254,3.3.82,2.187,1.23,3.28.82,2.208,1.245,3.307c.308.8.62,1.593.967,2.374a2.919,2.919,0,0,0,2.17,1.66,7.232,7.232,0,0,0,3.188-.033,4,4,0,0,0,.71-.25,1.129,1.129,0,0,0,.664-.976,2.144,2.144,0,0,0,.01-.3q0-10.224-.008-20.45a3.035,3.035,0,0,0-.2-1.088,1.78,1.78,0,0,0-1.314-1.014,10.537,10.537,0,0,0-1.157-.223c-.2-.029-.282-.105-.271-.311.015-.282.012-.567,0-.85-.008-.2.064-.263.263-.259q3.825.022,7.649.028c1.275,0,2.55-.023,3.825-.017a20.731,20.731,0,0,1,5.106.617A7.275,7.275,0,0,1,551.343,4a6.751,6.751,0,0,1,1.008,3.832,6.246,6.246,0,0,1-2.786,5.082,14.719,14.719,0,0,1-4.253,2.118c-.287.1-.571.2-.863.277-.221.057-.263.131-.13.331.658.978,1.294,1.97,1.96,2.944.968,1.413,1.911,2.845,2.944,4.206a12.248,12.248,0,0,0,3.433,3.166,5.749,5.749,0,0,0,2.552.667c.639.055.589-.025.588.617,0,.844,0,.837-.835.815-.578-.015-1.153.017-1.727-.019a12.046,12.046,0,0,1-5.476-1.549A10.923,10.923,0,0,1,544.7,23.8c-1.167-1.492-2.273-3.033-3.4-4.559-.615-.836-1.216-1.682-1.815-2.532A.432.432,0,0,0,539,16.5c-.247.053-.5.077-.742.146a.3.3,0,0,0-.18.22c-.007,2.65-.012,5.3.005,7.949A1.127,1.127,0,0,0,539,25.889a15.619,15.619,0,0,0,1.787.305c.31.032.4.134.376.425a4.792,4.792,0,0,0,0,.758c.015.217-.053.278-.273.271-1.011-.035-2.023-.076-3.034-.073-2.57.009-5.14.053-7.71.06-1.262,0-2.529-.065-3.794-.06-2.734.009-5.463.04-8.2.073-.267,0-.4-.04-.355-.343a2.825,2.825,0,0,0,0-.667c-.034-.306.075-.412.39-.443a12.544,12.544,0,0,0,1.665-.3,1.037,1.037,0,0,0,.814-1.405c-.177-.608-.4-1.2-.615-1.8-.363-1-.736-2-1.1-3-.143-.387-.275-.779-.439-1.157a.366.366,0,0,0-.284-.136c-.931-.01-1.862-.006-2.793-.006-1.852,0-3.7.005-5.556-.005-.289,0-.433.053-.535.368-.567,1.743-1.179,3.47-1.758,5.209a1.3,1.3,0,0,0,.946,1.79,9.736,9.736,0,0,0,2.65.456c.3.011.392.124.368.406a3.565,3.565,0,0,0,0,.727c.036.284-.092.321-.328.306-.434-.027-.869-.046-1.3-.045q-3.884.008-7.77.027h-.371m36.289-12.512a2.232,2.232,0,0,0,.251-.015c.625-.117,1.251-.233,1.874-.357a13.418,13.418,0,0,0,3.865-1.343,5.8,5.8,0,0,0,2.773-3.116,7.246,7.246,0,0,0,.052-5.13A4.592,4.592,0,0,0,542.8,1.945c-1.453-.14-2.925-.072-4.389-.105-.288-.006-.351.116-.35.383q.011,6.261.005,12.522v.374M517.9,16.844c-1.383-3.738-2.744-7.412-4.1-11.09l-.088.016-3.7,11.074Z" transform="translate(-475.234 2.401)" fill="#213056"/>
            <path id="Path_3" data-name="Path 3" d="M1511.889,25.6c.186-.54.349-1.011.51-1.484q.551-1.615,1.1-3.231.486-1.429.974-2.858c.368-1.067.74-2.131,1.1-3.2s.725-2.135,1.089-3.2.741-2.152,1.109-3.229c.1-.3.214-.609.3-.921a.6.6,0,0,0-.322-.72,5.164,5.164,0,0,0-1.209-.439,16.414,16.414,0,0,0-1.8-.239c-.252-.024-.331-.116-.315-.36a5.985,5.985,0,0,0,0-.789c-.013-.221.076-.268.284-.267q4.28.012,8.56.007l19-.008c.532,0,.628.066.7.581.158,1.069.289,2.142.427,3.214.074.571.129,1.145.219,1.713.029.182-.006.246-.181.246-.395,0-.791.022-1.183-.012-.108-.009-.229-.166-.3-.282-.359-.593-.673-1.216-1.061-1.787a4.069,4.069,0,0,0-2.208-1.8,5.56,5.56,0,0,0-1.4-.235c-1.577-.03-3.157-.018-4.735-.015-.434,0-.6.171-.6.616q0,5.02-.006,10.041c0,.2.075.263.266.263,1.73-.006,3.461.017,5.191-.017,1.524-.031,1.988-.664,2.456-1.879a5.376,5.376,0,0,0,.189-.668c.041-.171.119-.263.312-.254.282.012.566.006.85,0,.175,0,.239.041.22.249a36.84,36.84,0,0,0,0,6.724c.02.217-.041.3-.257.294a6.22,6.22,0,0,0-.728,0c-.258.022-.335-.105-.42-.328a14.994,14.994,0,0,0-.7-1.625,1.556,1.556,0,0,0-1.159-.747,6.944,6.944,0,0,0-1.265-.127c-1.528-.014-3.056,0-4.584-.011-.274,0-.368.069-.368.355q.012,5.233.006,10.466c0,.55.158.719.7.711,1.659-.024,3.32-.009,4.974-.105a4.118,4.118,0,0,0,3.726-2.576c.421-.924.88-1.831,1.329-2.742.035-.072.126-.163.194-.165.481-.014.963-.008,1.494-.008-.1.355-.177.662-.266.967a26.435,26.435,0,0,0-1.027,5.743c0,.07-.018.141-.019.21,0,.231-.1.3-.343.3-3-.041-5.99-.1-8.984-.1-3.259,0-6.516.053-9.773.1-.248,0-.325-.077-.315-.311.012-.293.015-.587,0-.88-.011-.2.081-.257.259-.289.645-.118,1.293-.222,1.927-.384a1.18,1.18,0,0,0,.955-1.265q0-10.588,0-21.176c0-.888-.519-1.179-1.27-1.371a8.219,8.219,0,0,0-3.874.013,2.263,2.263,0,0,0-1.692.995,9.315,9.315,0,0,0-.488,1.266c-.38,1.072-.752,2.148-1.126,3.222q-.616,1.769-1.229,3.537c-.421,1.209-.845,2.414-1.265,3.621q-.621,1.783-1.238,3.567-.546,1.569-1.1,3.136l-1.1,3.166c-.4,1.141-.789,2.284-1.2,3.421a.326.326,0,0,1-.247.168c-.536.016-1.073.023-1.608,0-.1,0-.232-.15-.277-.26-.225-.549-.425-1.108-.638-1.662q-.616-1.607-1.237-3.21-.625-1.619-1.253-3.236-.7-1.8-1.389-3.6l-1.411-3.661c-.516-1.333-1.037-2.664-1.552-4-.464-1.2-.921-2.406-1.387-3.607-.237-.609-.463-1.224-.736-1.818a2.283,2.283,0,0,0-2.008-1.193c-.28-.04-.562-.078-.844-.1-.166-.012-.236-.073-.232-.241.007-.315.006-.627,0-.94,0-.163.046-.227.228-.227q5.57.009,11.139,0c.206,0,.268.066.26.263-.012.292-.009.586,0,.88.005.179-.067.238-.243.267q-1.014.166-2.021.373a1.487,1.487,0,0,0-.466.21.723.723,0,0,0-.3.991c.719,1.893,1.43,3.785,2.152,5.673.66,1.729,1.333,3.453,1.994,5.182.513,1.344,1.014,2.693,1.525,4.038q.526,1.383,1.058,2.763a2.233,2.233,0,0,0,.18.3" transform="translate(-1417.554 -1.967)" fill="#213056"/>
            <path id="Path_4" data-name="Path 4" d="M91.035,771.634h67.574q9.288,0,18.578,0c1.284,0,2.569.063,3.853.1.08,0,.161.019.241.021.284,0,.4.115.392.426-.026.67-.008.7-.683.705-2.9.041-5.806.091-8.71.093q-18.306.015-36.612,0H16.427q-6.269,0-12.537-.016c-.95,0-1.9-.048-2.851-.078-.131,0-.26-.033-.391-.047-.2-.024-.267-.142-.275-.332-.027-.713-.021-.757.688-.772,2.437-.048,4.875-.1,7.313-.1q21.462-.013,42.924,0H91.035" transform="translate(-0.179 -728.618)" fill="#213056"/>
            <path id="Path_5" data-name="Path 5" d="M2435.5,27.559c-1.893.036-3.785.069-5.678.114-.263.006-.4-.027-.36-.339a2.916,2.916,0,0,0,0-.7c-.032-.311.105-.383.394-.417a14.052,14.052,0,0,0,1.665-.3,1.043,1.043,0,0,0,.81-1.433c-.174-.588-.385-1.166-.595-1.743-.364-1-.739-2-1.11-3-.129-.349-.281-.692-.382-1.049-.072-.252-.21-.287-.439-.284-1.022.011-2.044,0-3.066,0-1.73,0-3.46.006-5.191-.005-.288,0-.432.05-.534.365-.567,1.743-1.179,3.47-1.76,5.208a1.3,1.3,0,0,0,.943,1.791,10.107,10.107,0,0,0,2.681.459c.263.011.362.109.345.368a5.314,5.314,0,0,0,0,.789c.022.249-.091.291-.3.28-.455-.024-.91-.049-1.367-.047q-4.128.014-8.254.053c-.271,0-.329-.071-.312-.315a8.346,8.346,0,0,0,0-.849c-.006-.192.074-.244.263-.277.733-.127,1.472-.245,2.189-.439a3.078,3.078,0,0,0,2.085-2.033c.49-1.3.909-2.625,1.359-3.94.467-1.363.939-2.723,1.4-4.086.368-1.077.721-2.158,1.087-3.236s.741-2.151,1.107-3.228.726-2.155,1.091-3.235.736-2.155,1.1-3.23c.27-.792.546-1.581.8-2.377.079-.246.179-.363.462-.356.789.021,1.577.015,2.366,0a.351.351,0,0,1,.385.26q1.092,2.911,2.189,5.821c.756,2.017,1.5,4.036,2.26,6.052.709,1.884,1.433,3.761,2.141,5.645.66,1.752,1.295,3.512,1.969,5.257a12.448,12.448,0,0,0,.842,1.765,2.63,2.63,0,0,0,1.8,1.177,10.087,10.087,0,0,0,1.349.188c.207.018.259.105.255.284-.006.3-.014.607,0,.91.012.215-.074.247-.267.242-1.912-.044-3.823-.077-5.734-.114M2425.451,5.75c-.073.061-.1.071-.1.087q-.518,1.545-1.033,3.091c-.412,1.242-.816,2.486-1.229,3.727-.431,1.3-.87,2.6-1.3,3.894-.11.333-.1.338.236.338h7.162c.1,0,.21-.017.375-.033-1.377-3.722-2.733-7.394-4.108-11.1" transform="translate(-2285.967 2.378)" fill="#213056"/>
            <path id="Path_6" data-name="Path 6" d="M1808.726,1034.522c.81,2.1,1.616,4.2,2.451,6.361.435-1.1.848-2.142,1.251-3.183s.8-2.1,1.215-3.18h2.708v.388c-.246.049-.483.094-.719.146a.483.483,0,0,0-.417.454c-.015.13-.024.261-.026.392v5.613c0,.841.089.946.906,1.1.087.016.175.028.271.043v.388H1812.6v-.385c.195-.025.392-.052.59-.076.526-.066.724-.283.725-.819,0-1.4,0-2.791,0-4.187v-1.9l-.077-.026c-.043.089-.091.176-.128.267q-1.347,3.365-2.7,6.729c-.048.12-.033.3-.263.307s-.217-.18-.263-.3q-1.307-3.475-2.606-6.956c-.024-.064-.053-.126-.1-.248a.923.923,0,0,0-.049.173q.011,2.839.029,5.673a2.346,2.346,0,0,0,.065.449.933.933,0,0,0,.761.766c.2.048.407.1.616.158v.387h-3.436v-.389c.192-.04.4-.075.6-.127a.847.847,0,0,0,.719-.821,8.717,8.717,0,0,0,.059-.937c.006-1.426,0-2.852,0-4.278,0-1.1-.243-1.387-1.331-1.577v-.392Z" transform="translate(-1710.672 -977.686)" fill="#213056"/>
            <path id="Path_7" data-name="Path 7" d="M672.26,1040.553c0-1.584,0-3.1,0-4.618a2.965,2.965,0,0,0-.076-.54.8.8,0,0,0-.64-.683c-.254-.061-.5-.135-.77-.206v-.375h3.478v.377c-.225.053-.456.114-.688.167a.766.766,0,0,0-.623.726,7.233,7.233,0,0,0-.065.845q-.009,3.065,0,6.129v.319a.642.642,0,0,1-.78-.288c-1.555-2.116-3.129-4.219-4.7-6.325-.064-.086-.132-.168-.23-.292-.012.093-.024.137-.024.182q.012,2.411.027,4.823a3.334,3.334,0,0,0,.057.449.937.937,0,0,0,.776.854c.216.049.431.1.661.161v.391h-3.491v-.392c.223-.057.436-.116.651-.166a.84.84,0,0,0,.678-.82c.032-.311.056-.625.057-.937.006-1.367,0-2.734,0-4.1a1.417,1.417,0,0,0-1.283-1.653c-.086-.023-.171-.048-.263-.074v-.4c.662,0,1.318.024,1.97-.01a.79.79,0,0,1,.763.387c1.423,1.938,2.866,3.862,4.3,5.79.058.078.12.154.217.278" transform="translate(-629.883 -977.285)" fill="#213056"/>
            <path id="Path_8" data-name="Path 8" d="M2330.228,1042.978a.649.649,0,0,1-.8-.322c-1.612-2.186-3.239-4.364-4.889-6.571a.777.777,0,0,0-.039.158q.01,2.427.027,4.854a3.486,3.486,0,0,0,.053.421.958.958,0,0,0,.819.884c.206.045.41.1.625.148v.385h-3.49v-.387c.21-.053.432-.118.654-.17a.828.828,0,0,0,.665-.8,8.767,8.767,0,0,0,.059-.937c.006-1.367,0-2.734,0-4.1a1.423,1.423,0,0,0-1.295-1.674l-.246-.069v-.4c.789,0,1.567-.006,2.343.009.082,0,.178.111.238.192,1.543,2.063,3.082,4.129,4.646,6.226a1.26,1.26,0,0,0,.031-.183v-4.035c0-.052,0-.1,0-.151-.07-1.426-.3-1.346-1.291-1.6-.066-.017-.133-.033-.205-.053v-.384h3.475v.384c-.228.056-.459.114-.692.17a.758.758,0,0,0-.609.7,6.57,6.57,0,0,0-.067.845q-.01,3.064-.005,6.129v.335" transform="translate(-2200.115 -977.571)" fill="#213056"/>
            <path id="Path_9" data-name="Path 9" d="M1164.413,1040.559h.375c-.053.841-.105,1.665-.158,2.512h-7.1v-.389c.186-.025.373-.052.561-.076.442-.057.64-.253.642-.691q.008-3.065,0-6.128a.6.6,0,0,0-.493-.67,3.531,3.531,0,0,0-.349-.094c-.117-.028-.234-.052-.364-.077v-.4h6.6v2.033h-.368c-.229-.359-.434-.712-.672-1.044a1.109,1.109,0,0,0-.925-.5c-.705,0-1.411,0-2.132,0v3.37c.44,0,.873.018,1.3,0a.934.934,0,0,0,.863-.655c.087-.232.146-.473.219-.718h.406v3.315h-.4c-.069-.236-.135-.485-.213-.73a.945.945,0,0,0-.922-.7c-.412-.02-.825,0-1.252,0,0,1.019-.018,2.026.009,3.033a.548.548,0,0,0,.594.6c.754.027,1.511,0,2.266-.025a.814.814,0,0,0,.679-.452c.274-.49.54-.986.828-1.513" transform="translate(-1096.511 -977.715)" fill="#213056"/>
            <path id="Path_10" data-name="Path 10" d="M2108.759,1036.727h-.361c-.239-.374-.446-.728-.684-1.059a1.032,1.032,0,0,0-.836-.481c-.736-.007-1.472,0-2.218,0v3.392c.513-.028,1.035-.031,1.548-.094a.8.8,0,0,0,.612-.578c.091-.233.15-.479.228-.736h.41v3.312h-.4c-.071-.244-.136-.494-.215-.739a.932.932,0,0,0-.894-.692c-.42-.022-.845,0-1.283,0,0,1-.016,1.989.007,2.977a.587.587,0,0,0,.639.662c.744.03,1.491,0,2.236-.033a.813.813,0,0,0,.676-.455c.275-.49.54-.986.826-1.51h.373c-.053.835-.105,1.667-.158,2.518h-7.105v-.393c.2-.026.4-.049.6-.078a.6.6,0,0,0,.6-.662q.011-3.079,0-6.158a.589.589,0,0,0-.5-.665c-.228-.074-.465-.118-.709-.179v-.38h6.608Z" transform="translate(-1991.472 -977.847)" fill="#213056"/>
            <path id="Path_11" data-name="Path 11" d="M1386.645,1036.694h.4c.123.316.222.644.368.946a2.441,2.441,0,0,0,2.292,1.595,1.414,1.414,0,0,0,1.489-.911,1.7,1.7,0,0,0-.578-1.926,6,6,0,0,0-1.031-.491c-.454-.193-.927-.342-1.371-.554a2.226,2.226,0,0,1-1.361-2.536,2.464,2.464,0,0,1,2.031-1.9,3.459,3.459,0,0,1,2.449.542c.128-.32.323-.526.729-.368v2.794h-.44a8.723,8.723,0,0,0-.284-.838,4.854,4.854,0,0,0-.5-.924,1.751,1.751,0,0,0-1.712-.694,1.231,1.231,0,0,0-1.116.89,1.3,1.3,0,0,0,.394,1.461,5.926,5.926,0,0,0,1.176.661c.536.254,1.095.459,1.63.712a2.362,2.362,0,0,1,.29,4.006,3.461,3.461,0,0,1-3.482.308c-.2-.079-.4-.185-.625-.292-.132.3-.3.564-.753.378Z" transform="translate(-1313.577 -974.221)" fill="#213056"/>
            <path id="Path_12" data-name="Path 12" d="M2809.757,1031.4c.121-.338.322-.511.714-.368v2.792h-.438a8.563,8.563,0,0,0-.283-.831,4.859,4.859,0,0,0-.5-.925,1.751,1.751,0,0,0-1.71-.7,1.232,1.232,0,0,0-1.119.886,1.3,1.3,0,0,0,.388,1.462,5.85,5.85,0,0,0,1.176.663c.545.26,1.115.466,1.659.727a2.36,2.36,0,0,1,.295,3.971,3.449,3.449,0,0,1-3.506.332c-.2-.078-.4-.186-.627-.293-.133.289-.291.568-.754.377v-2.839h.323a14.253,14.253,0,0,0,.927,1.66,2.158,2.158,0,0,0,2.38.8,1.436,1.436,0,0,0,.92-1.964,1.693,1.693,0,0,0-1.037-1.072c-.609-.239-1.227-.458-1.827-.718a2.277,2.277,0,0,1-1.408-1.447,2.375,2.375,0,0,1,1.931-3.044,3.433,3.433,0,0,1,2.5.532" transform="translate(-2657.42 -974.173)" fill="#213056"/>
            <path id="Path_13" data-name="Path 13" d="M1588.089,1043.188h-4v-.4c.29-.043.578-.079.863-.13a.555.555,0,0,0,.492-.564c0-.071.01-.141.01-.21v-6.523c0-.069-.007-.138-.013-.255-.461.027-.915.033-1.363.09a.69.69,0,0,0-.421.263c-.334.461-.636.946-.951,1.419l.068.059h-.4v-2.279h7.446v2.278h-.325c-.266-.445-.507-.874-.772-1.286a1.1,1.1,0,0,0-1-.517c-.312.007-.624,0-.959,0,0,.105-.013.2-.013.3v6.341c0,.624.1.751.706.888.206.047.415.085.641.131Z" transform="translate(-1499.017 -977.819)" fill="#213056"/>
            <path id="Path_14" data-name="Path 14" d="M2581.385,1042.814v.384h-4.007v-.4c.221-.025.45-.047.677-.076a.659.659,0,0,0,.684-.754v-6.847c-.478.028-.941.037-1.4.093a.647.647,0,0,0-.394.252c-.333.461-.638.943-.954,1.419l.073.064h-.4v-2.274h7.438v2.26c-.278.092-.459.026-.509-.275a.15.15,0,0,0-.009-.029c-.549-1.308-.991-1.568-2.54-1.475,0,.092-.013.188-.013.284v6.341c0,.638.1.758.729.9.2.047.411.082.625.125" transform="translate(-2440.089 -977.838)" fill="#213056"/>
            <path id="Path_15" data-name="Path 15" d="M917.421,1034.967v-.4h3.161v.386c-.079.021-.162.05-.247.065a1.222,1.222,0,0,0-.966.781c-.444,1.079-.894,2.155-1.329,3.238-.558,1.391-1.1,2.786-1.654,4.184h-.5l-1.607-4.294c-.331-.886-.683-1.765-.984-2.661-.24-.716-.613-1.244-1.435-1.291v-.4h3.532v.39l-.589.078c-.481.065-.552.178-.38.639q.7,1.879,1.413,3.757c.232.617.462,1.235.716,1.917.315-.792.613-1.518.894-2.248.371-.957.749-1.911,1.092-2.878.3-.855.158-1.065-.749-1.2-.118-.017-.236-.041-.372-.065" transform="translate(-863.756 -977.734)" fill="#213056"/>
            <path id="Path_16" data-name="Path 16" d="M506.33,1034.958v-.4h3.833v.391c-.2.03-.41.053-.616.093-.536.1-.665.263-.666.829v5.886c0,.526.133.7.653.821.2.049.412.081.628.123v.382h-3.826v-.392l.648-.073c.432-.05.613-.241.613-.669q0-3.08,0-6.159c0-.388-.09-.508-.469-.639-.133-.046-.27-.082-.407-.115s-.254-.053-.392-.079" transform="translate(-479.545 -977.724)" fill="#213056"/>
          </g>
        </svg>
      </div>

      <!-- Login Form -->
      <div v-if="!isNewPasswordRequired" class="login-form">
        <h2>Login</h2>
        <p class="login-subtitle">Please sign in to continue</p>

        <div class="login-field">
          <label for="username">Username</label>
          <input
            id="username"
            type="text"
            v-model="username"
            :class="['login-input', { 'input-error': inputColor === 'red' }]"
            autocapitalize="off"
            spellcheck="false"
            autocorrect="off"
            @keyup.enter="authenticateUser"
          />
        </div>

        <div class="login-field">
          <label for="password">Password</label>
          <input
            id="password"
            type="password"
            v-model="password"
            :class="['login-input', { 'input-error': inputColor === 'red' }]"
            autocomplete="off"
            @keyup.enter="authenticateUser"
          />
        </div>

        <p v-if="inputColor === 'red'" class="error-message">
          Invalid username or password.
        </p>

        <button class="login-btn" @click="authenticateUser">SIGN IN</button>
      </div>

      <!-- New Password Form -->
      <div v-if="isNewPasswordRequired" class="login-form">
        <h2>Set New Password</h2>
        <p class="login-subtitle">You need to set a new password to continue</p>

        <div class="login-field">
          <label for="newPassword">New Password</label>
          <input
            id="newPassword"
            type="password"
            v-model="newPassword"
            :class="['login-input', { 'input-error': inputColor === 'red' }]"
            autocomplete="off"
            @keyup.enter="submitNewPassword"
          />
        </div>

        <button class="login-btn" @click="submitNewPassword">SUBMIT NEW PASSWORD</button>
      </div>

    </div>
  </div>
</template>

<script>
import store from "@/store";
import { CognitoUserPool, CognitoUser, AuthenticationDetails } from 'amazon-cognito-identity-js';
import api from "@/Api";

export default {
  name: "Login",
  mixins: [],
  store,
  data() {
    return {
      username: '',
      password: '',
      newPassword: '',
      cognitoUser: null,
      userAttributes: null,
      isNewPasswordRequired: false,
      inputColor: "#fff",
      poolData: {
        UserPoolId: 'eu-central-2_nLZXCM137',
        ClientId: '4if100um8m6t8coa12dtv9vifm',
      }
    };
  },
  computed: {},
  methods: {
    authenticateUser() {
      const userPool = new CognitoUserPool(this.poolData);

      if (!this.username || !this.password) return;

      const authenticationDetails = new AuthenticationDetails({
        Username: this.username,
        Password: this.password,
      });

      const userData = {
        Username: this.username,
        Pool: userPool,
      };

      const cognitoUser = new CognitoUser(userData);

      cognitoUser.authenticateUser(authenticationDetails, {
        onSuccess: (result) => {
          this.sendIdTokenToBackend(result.getIdToken().getJwtToken(), result.getAccessToken().getJwtToken())
            .then(redirectUrl => {
              if (redirectUrl) {
                let startseite = this.$router.resolve({ name: redirectUrl });
                window.location.href = startseite.href;
              }
            })
            .catch(err => {
              console.error('Error retrieving redirect URL:', err);
            });
        },
        onFailure: (err) => {
          console.error('Authentication failed:', err);
          this.inputColor = "red";
        },
        newPasswordRequired: (userAttributes) => {
          this.cognitoUser = cognitoUser;
          this.userAttributes = userAttributes;
          this.isNewPasswordRequired = true;
        },
      });
    },

    submitNewPassword() {
      if (this.cognitoUser && this.newPassword) {
        this.cognitoUser.completeNewPasswordChallenge(this.newPassword, {}, {
          onSuccess: () => {
            this.isNewPasswordRequired = false;
            this.authenticateUser();
          },
          onFailure: (err) => {
            console.error('Failed to change password:', err);
          },
        });
      }
    },

    sendIdTokenToBackend(idToken, accessToken) {
      const params = new URLSearchParams();
      params.append("idToken", idToken);
      params.append("accessToken", accessToken);

      return api.post("/get-redirect-url", params)
        .then(response => {
          if (response.status !== 200) {
            throw new Error('Network response was not ok');
          }
          return response.data;
        })
        .then(data => data.redirectUrl)
        .catch(err => {
          console.error('Failed to send id token to backend:', err);
          throw err;
        });
    },
  }
};
</script>

<style lang="scss">
body {
  background: #f0f2f8;
  color: #213056;
  overflow-x: hidden;
}

#login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0px 3px 20px rgba(0, 0, 0, 0.1);
  padding: 48px;
  width: 100%;
  max-width: 420px;
}

.login-logo {
  text-align: center;
  margin-bottom: 36px;
}

.login-logo img {
  max-width: 160px;
}

.login-form h2 {
  font-size: 22px;
  font-weight: 700;
  color: #213056;
  margin-bottom: 4px;
}

.login-subtitle {
  color: #8e97af;
  font-size: 14px;
  margin-bottom: 28px;
}

.login-field {
  margin-bottom: 20px;
}

.login-form label {
  display: block;
  font-size: 11px;
  font-weight: 600;
  color: #8e97af;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  margin-bottom: 8px;
}

.login-input {
  width: 100%;
  border: 1.5px solid #c5cbdc;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 15px;
  color: #213056;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  font-family: inherit;
}

.login-input:focus {
  border-color: #213056;
}

.login-input.input-error {
  border-color: #e74c3c;
}

.error-message {
  color: #e74c3c;
  font-size: 13px;
  margin-top: -12px;
  margin-bottom: 16px;
}

.login-btn {
  width: 100%;
  background-color: #213056;
  color: white;
  border: none;
  border-radius: 24px;
  height: 50px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.08em;
  cursor: pointer;
  margin-top: 8px;
  transition: background-color 0.2s;
  font-family: inherit;
}

.login-btn:hover {
  background-color: #2d4070;
}
</style>
